import { useRoute } from '#imports'
import { computed } from 'vue'

import { urlHashToObject } from '@backmarket/utils/url/urlHashToObject'

import {
  HASH_MESSAGE_KEY,
  HASH_MESSAGE_SOURCE_KEY,
} from '../utils/removeSeededMessageFromHash'
import { sanitizeSeededMessage } from '../utils/sanitizeSeededMessage'

/**
 * Reads a seeded launch out of the URL hash, for the web-sidebar host. Unlike
 * the web-page host's query params, this has to stay reactive to route.hash
 * rather than only being read once on mount, to support onsite links that
 * change the hash via client-side navigation without necessarily remounting
 * the host.
 */
export function useShoppingAssistantHashContext() {
  const route = useRoute()

  const seededMessage = computed<string>(() => {
    const values = urlHashToObject(route.hash)[HASH_MESSAGE_KEY]

    return sanitizeSeededMessage(values?.length === 1 ? values[0] : undefined)
  })

  const entrySource = computed<string>(() => {
    const values = urlHashToObject(route.hash)[HASH_MESSAGE_SOURCE_KEY]

    return values?.length === 1 ? values[0].trim() : ''
  })

  const isSeededLaunch = computed<boolean>(() => seededMessage.value !== '')

  return {
    seededMessage,
    entrySource,
    isSeededLaunch,
  }
}
